// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  close: () => 'Zatvori',
  error: () => 'Greška',
  warn: () => 'Upozorenje',
  info: () => 'Informacije',
  confirmation: () => 'Potvrda',
  progressIndeterminate: () => 'U toku',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Između ' + p['FROM_SECTION'] + ' i ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nisu pronađeni odeljci koji se podudaraju.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => "Pritisnite 'enter' da biste izabrali vrednost.",
  indexer_touchInstructionText: () =>
    'Dvaput dodirnite i zadržite da biste prešli na režim gestikulacije, a zatim prevucite nagore ili nadole da biste prilagodili vrednost.',
  inputPassword_show: () => 'Prikaži lozinku',
  inputPassword_hide: () => 'Sakrij lozinku',
  inputPassword_hidden: () => 'Lozinka je skrivena',
  formControl_clear: () => 'Obriši',
  formControl_loading: () => 'Učitava se',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maksimalna dužina od ' + p['MAX_LENGTH'] + ' je premašena.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Preostali broj znakova je ' + p['CHARACTER_COUNT'] + '.',
  formControl_requiredMessageDetail: () => 'Unesite vrednost.',
  select_requiredMessageDetail: () => 'Izaberite vrednost.',
  select_noMatchesFound: () => 'Nije pronađen nijedan pogodak.',
  select_oneMatchFound: () => 'Pronađen je jedan rezultat',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Pronađenih podudaranja: ' + p['TOTAL_SIZE'],
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Pronađenih podudaranja: ' + p['TOTAL_SIZE'] + ' ili više',
  selectMultiple_selectedValues: () => 'Izabrane vrednosti',
  selectMultiple_showSelectedValues: () => 'Prikazuju se samo izabrane vrednosti.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Izabranih vrednosti: ' + p['VALUE_COUNT'] + ' .',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Pritisnite tastere Backspace ili Delete da biste uklonili izabranu vrednost.',
  selectMultiple_apply: () => 'Primeni',
  selectMultiple_back: () => 'Nazad',
  selector_selected: () => 'Polje za potvrdu je označeno',
  selector_unselected: () => 'Polje za potvrdu nije označeno',
  userAssistance_learnMore: () => 'Saznajte više',
  userAssistance_required: () => 'Obavezno',
  filePicker_singleFileUploadError: () => 'Otpremajte jednu po jednu datoteku',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Ne možete da otpremate datoteke tipa ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Ne možete da otpremate datoteke tipa: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'nepoznato',
  filePicker_dropzonePrimaryText: () => 'Prevucite i otpustite',
  filePicker_dropzoneSecondaryText: () => 'Izaberite datoteku ili je otpustite ovde',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Izaberite ili prevucite datoteke ovde',
  filePicker_addFiles: () => 'Dodaj datoteke',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Povećaj',
  inputNumber_decrease: () => 'Smanji',
  inputNumber_converterParseError: () => 'Unesite broj.',
  noData_message: () => 'Nema stavki za prikaz',
  message_navigationFromMessagesRegion: () =>
    'Prelazak na oblast za poruke. Pritisnite F6 da biste se vratili na element koji je pre toga bio u fokusu.',
  message_navigationToMessagesRegion: () =>
    'Oblast za poruke sadrži nove poruke. Pritisnite F6 da biste prešli na region najnovije poruke.',
  messageToast_allMessagesClosed: () => 'Sve iskačuće poruke su zatvorene.',
  expandableList_groupCollapse: () => 'Skupljeno',
  expandableList_groupExpand: () => 'Prošireno',
  expandableList_expandCollapseInstructionText: () =>
    'Koristite strelice da biste proširivali i skupljali',
  list_suggestion: () => 'Predlog',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Korak ' + p['currentStep'] + ' od ' + p['numberOfSteps'],
  train_current: () => 'Trenutno',
  train_visited: () => 'Posećeno',
  train_not_visited: () => 'Nije posećeno',
  train_message_type: () => 'Tip poruke',
  viz_drillable: () => 'Može da se detaljno analizira',
  dataVisualization_stateSelected: () => 'Izabrano',
  dataVisualization_stateUnselected: () => 'Neizabrano',
  dataVisualization_noData: () => 'Nema podataka za prikaz'
};
export default bundle;
